import api from './axiosInstance';
import { OrganizationEnums } from '../utils/organizationEnums';

export const getOrganizationEnums = async (): Promise<OrganizationEnums> => {
  const { data } = await api.get<OrganizationEnums>('/settings/enums');
  return data;
};

export const updateOrganizationEnums = async (
  enums: OrganizationEnums
): Promise<OrganizationEnums> => {
  const { data } = await api.put<OrganizationEnums>('/settings/enums', enums);
  return data;
};
